import { SearchCriteria } from "./search-criteria";

export class GetBookingCriteria extends SearchCriteria {
  public BookingId: number;

}
